import { render, staticRenderFns } from "./FieldFile.vue?vue&type=template&id=5c66f5c8&scoped=true"
import script from "./FieldFile.vue?vue&type=script&lang=js"
export * from "./FieldFile.vue?vue&type=script&lang=js"
import style0 from "./FieldFile.vue?vue&type=style&index=0&id=5c66f5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c66f5c8",
  null
  
)

export default component.exports